/* Keep service and location context when customers open the visit form. */
(() => {
  const handle = window.location.pathname.split('/').filter(Boolean).pop();
  const services = ['daycare', 'boarding', 'grooming', 'dental'];
  const locations = ['echo-park', 'sherman-oaks', 'pasadena'];
  const context = services.includes(handle) ? ['service', handle]
    : locations.includes(handle) ? ['location', handle] : null;
  if (!context) return;
  const update = link => {
    if (!link || !link.getAttribute('href')) return;
    const url = new URL(link.getAttribute('href'), window.location.href);
    if (url.origin !== window.location.origin || !/\/pages\/request-a-visit\/?$/.test(url.pathname)) return;
    if (!url.searchParams.has(context[0])) url.searchParams.set(...context);
    link.setAttribute('href', url.pathname + url.search + url.hash);
  };
  document.querySelectorAll('a[href]').forEach(update);
  document.addEventListener('click', event => update(event.target.closest?.('a[href]')));
})();
